import { useEffect, useRef } from "react";

/**
 * Wires the Agent Audit Log header download button: the shared header owns a
 * `downloadTrigger` number, each tab calls this with `start` from `useAalExport`
 * and a `buildPayload` that snapshots the tab's current filters. When the
 * counter changes the payload is rebuilt and submitted. Mount values are
 * ignored so tab switches never auto-export.
 */
export const useDownloadOnTrigger = <TPayload>(
  downloadTrigger: number,
  start: (payload: TPayload) => void,
  buildPayload: () => TPayload,
): void => {
  const initialTriggerRef = useRef(downloadTrigger);
  const buildPayloadRef = useRef(buildPayload);
  buildPayloadRef.current = buildPayload;

  useEffect(() => {
    if (downloadTrigger === initialTriggerRef.current) return;
    start(buildPayloadRef.current());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadTrigger]);
};
